import React from "react"
import { Link } from "gatsby"
import { GatsbyImage } from "gatsby-plugin-image"
import parse from "html-react-parser"
import { Row, Container, Col, Breadcrumb, Button } from "react-bootstrap"
import Badge from 'react-bootstrap/Badge'
import { FaPrint } from "react-icons/fa"

import Layout from "../components/layout"
import Seo from "../components/seo"
import SocialMedia from "../components/socialMedia"
import RecipePrint from "../components/recipePrint"
import { AdSide1, AdSide2, AdInArtricle, AdFooter } from '../components/ads'

const addRecipeSubtitleClass = ( content, subtitle ) => {
  const pos = content.indexOf(subtitle);
  if (pos != -1) {
    content = content.substr(0,pos)+'<span class="recipe-subtitle">'+subtitle+'</span>'+content.substr(pos+subtitle.length);
  }
  return content
}

const Recipe = ({ post, featuredImage, location }) => {
  const print_mode = location.search == '?print';

  var content = post.content;
  if (!!content) {
    const pos = content.indexOf('<strong>INGREDIENTS</strong>');
    //const pos = 1;
    console.log('pos='+pos);
    var content_part1 = content;
    var content_part2 = "";
    if (pos != -1) {
      content_part1 = content.substring(0, pos) 
      content_part2 = content.substring(pos);
      //content_part2 = '<span class="recipe-subtitle">INGREDIENTS</span>'+content.substr(pos+28);
    } else {
      console.log('recipe has no INGREDIENT title: '+post.title)
    }

    content_part1 = addRecipeSubtitleClass(content_part1, "<strong>DESCRIPTION</strong>");
    content_part2 = addRecipeSubtitleClass(content_part2, "<strong>DESCRIPTION</strong>");
    content_part1 = addRecipeSubtitleClass(content_part1, "<strong>INGREDIENTS</strong>");
    content_part2 = addRecipeSubtitleClass(content_part2, "<strong>INGREDIENTS</strong>");
    content_part1 = addRecipeSubtitleClass(content_part1, "<strong>DIRECTIONS</strong>");
    content_part2 = addRecipeSubtitleClass(content_part2, "<strong>DIRECTIONS</strong>");

  }

  return (
    print_mode ? 
      <RecipePrint post={post} featuredImage={featuredImage} />
      :
     <>
      <Layout pageInfo={{ pageName: post.title || " Recipe" }}>
      <Seo title={post.title} keywords={[`recipe`]} description={post.excerpt} imageSrc={featuredImage.src}
        imageWidth={featuredImage.width} imageHeight={featuredImage.height} imageAlt={featuredImage.alt}
        url={post.uri}/>

      <Container>
      <div className="d-flex justify-content-between">
      <div className="d-flex justify-content-left pt-3 pb-2">
        <Breadcrumb>
          <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
          <Breadcrumb.Item href="/recipe-index">Recipes</Breadcrumb.Item>
          <Breadcrumb.Item active>{post.title}</Breadcrumb.Item>
        </Breadcrumb>
      </div>
      
      </div>
      <Row >
        <div className="d-flex flex-row justify-content-between pb-2 pe-4">
          <h1 itemProp="headline" className="d-flex flex-shrink-1">{parse(post.title)}</h1>
        </div>
      </Row>
      <Row>
        <div id="recipe-category-list" className="d-flex flex-wrap mb-2">
      {post.categories.nodes.map( category => (
          <Link to={category.uri} key={category.uri} className="m-1"><Badge bg="secondary" >{category.name}</Badge></Link>
         ))}
         </div>
      </Row>
      <Row>
        <Col xs={12} md={8}>
          <article
            className="blog-post"
            itemScope
            itemType="http://schema.org/Article"
          >
            <header>
              {/* if we have a featured image for this post let's display it */}
              {featuredImage?.image && (
                <GatsbyImage
                  image={featuredImage.image}
                  alt={featuredImage.alt}
                  style={{ marginBottom: 10 }}
                />
              )}
            </header>
            <div className="pt-0 pb-2 d-flex">
              <SocialMedia uri={"https://www.iloveitrecipes.com"+post.uri} position="right center"/>
              <Link to="?print"><Button variant="outline-primary" className="action-button ms-2">Print <FaPrint /></Button></Link>
            </div>
            {!!content && (
              <section itemProp="articleBody">
                {parse(content_part1)}
                {content_part2 && (<><AdInArtricle />{parse(content_part2)}</>)}
              </section>
            )}

            <hr />

            <footer>
            </footer>
          </article>
        </Col>
        <Col md={4}>
          <div className="ad_vertical">
          <AdSide1 />
          </div>
          <br/>
          <div className="ad_vertical mb-4">
          <AdSide2 />
          </div>
        </Col>
      </Row>
      <Row>
        <Col>
        <div className="ad_horizontal mb-4">
        <AdFooter />
        </div>
        </Col>
      </Row>
      </Container>
    </Layout>
    </>
  )
}

export default Recipe

